import classNames from 'classnames';
import React from 'react';
import styles from './styles.module.less';
import PropTypes from 'prop-types';

const KeyValueWidget = ({
  label = '',
  value = null,
  className = '',
  keyProp = null,
  compactValue = false,
  oneLine = false,
  labelClass = '',
  valueClass = '',
  onClick = () => {},
}) => {
  return (
    <div key={keyProp} className={classNames(className, oneLine && styles.oneLine)}>
      {label && (
        <div className={classNames('gx-guarnic-label', oneLine && 'gx-pr-2', labelClass)}>
          {label}
        </div>
      )}
      {value && (
        <div
          onClick={e => {
            e.stopPropagation();
            onClick?.();
          }}
          className={classNames('gx-guarnic-body', compactValue && styles.cutText, valueClass)}
        >
          {value}
        </div>
      )}
    </div>
  );
};

KeyValueWidget.propTypes = {
  label: PropTypes.any,
  value: PropTypes.any,
  className: PropTypes.string,
  keyProp: PropTypes.any,
  compactValue: PropTypes.bool,
  oneLine: PropTypes.bool,
  labelClass: PropTypes.string,
};

export { KeyValueWidget };
